import { defineMessages } from 'react-intl-next';

const messages: {
	administration: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	analytics: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	assets: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	atlassianStart: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	chat: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	collapseProductList: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	companyHub: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateExploreProductsBody: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateExploreProductsBodyAppify: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateExploreProductsLink: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateExploreProductsLinkAppify: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateExploreProductsTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorEmptyPartialResults: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorHeading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorHeadingLoggedOut: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorHeadingUnverified: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorImageAltText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorPartialResults: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorPartialResultsRefresh: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTextNetwork: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTextUnverified: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	errorTextUnverifiedAppify: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	expandProductList: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	goals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	home: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	join: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	manageList: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	productDescriptionCompass: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	productDescriptionConfluence: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	productDescriptionJiraServiceManagement: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	productDescriptionJiraSoftware: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	productDescriptionOpsgenie: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	projects: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rovo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rovoChat: {
        defaultMessage: string;
        description: string;
        id: string;
    }; rovoSearch: {
        defaultMessage: string;
        description: string;
        id: string;
    }; rovoStudio: {
        defaultMessage: string;
        description: string;
        id: string;
    };
	search: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	studio: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	emptyStateExploreProductsTitle: {
		id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.title',
		defaultMessage: 'Get started with cloud',
		description:
			'The title text for the empty state explore products content, which prompts users to try new products.',
	},
	emptyStateExploreProductsBody: {
		id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body',
		defaultMessage: 'Try a product to start collaborating with your team.',
		description:
			'The body text for the empty state explore products content, which prompts users to try new products.',
	},
	emptyStateExploreProductsLink: {
		id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link',
		defaultMessage: 'Explore products',
		description:
			'The text for the empty state explore products link, which prompts users to try new products.',
	},
	home: {
		id: 'fabric.atlassianSwitcher.atlassianHome',
		defaultMessage: 'Home',
		description: 'The text of a link redirecting the user to the Home site',
	},
	rovo: {
		id: 'fabric.atlassianSwitcher.rovo.no-translate',
		defaultMessage: 'Rovo',
		description: 'The text of a link redirecting the user to the rovo site',
	},
	administration: {
		id: 'fabric.atlassianSwitcher.administration',
		defaultMessage: 'Administration',
		description: 'The text of a link redirecting the user to Administration',
	},
	atlassianStart: {
		id: 'fabric.atlassianSwitcher.start',
		defaultMessage: 'Atlassian Start',
		description: 'The text of a link redirecting the user to the Start site',
	},
	assets: {
		id: 'fabric.atlassianSwitcher.assets',
		defaultMessage: 'Assets',
		description: 'The text of a link redirecting the user to the Assets',
	},
	analytics: {
		id: 'fabric.atlassianSwitcher.analytics',
		defaultMessage: 'Analytics',
		description: 'The text of a link redirecting the user to the Analytics',
	},
	companyHub: {
		id: 'fabric.atlassianSwitcher.companyHub',
		defaultMessage: 'Company Hub',
		description: 'The text of a link redirecting the user to the Company Hub',
	},
	goals: {
		id: 'fabric.atlassianSwitcher.goals',
		defaultMessage: 'Goals',
		description: 'The text of a link redirecting the user to the Goals',
	},
	projects: {
		id: 'fabric.atlassianSwitcher.projects',
		defaultMessage: 'Projects',
		description: 'The text of a link redirecting the user to the Projects',
	},
	teams: {
		id: 'fabric.atlassianSwitcher.teams',
		defaultMessage: 'Teams',
		description: 'The text of a link redirecting the user to the Teams',
	},
	search: {
		id: 'fabric.atlassianSwitcher.search',
		defaultMessage: 'Search',
		description: 'The text of a link redirecting the user to the Search',
	},
	chat: {
		id: 'fabric.atlassianSwitcher.chat',
		defaultMessage: 'Chat',
		description: 'The text of a link redirecting the user to the Chat',
	},
	studio: {
		id: 'fabric.atlassianSwitcher.studio',
		defaultMessage: 'Studio',
		description: 'The text of a link redirecting the user to the Studio',
	},
	rovoSearch: {
		id: 'fabric.atlassianSwitcher.rovo-search',
		defaultMessage: 'Rovo Search',
		description: 'The text of a link redirecting the user to Rovo Search app',
	},
	rovoChat: {
		id: 'fabric.atlassianSwitcher.rovo-chat',
		defaultMessage: 'Rovo Chat',
		description: 'The text of a link redirecting the user to the Rovo Chat app',
	},
	rovoStudio: {
		id: 'fabric.atlassianSwitcher.rovo-studio',
		defaultMessage: 'Rovo Studio',
		description: 'The text of a link redirecting the user to Rovo Studio app',
	},
	manageList: {
		id: 'fabric.atlassianSwitcher.manageList',
		defaultMessage: 'Manage list',
		description:
			'This text is for the action for a user to manage the values present in an editable list of links.',
	},
	errorEmptyPartialResults: {
		id: 'fabric.atlassianSwitcher.errorEmptyPartialResults',
		defaultMessage: "We can't display your apps right now.",
		description:
			'Heading of the error message when available apps returns a partial result and no sites',
	},
	errorHeading: {
		id: 'fabric.atlassianSwitcher.errorHeading',
		defaultMessage: 'Something’s gone wrong',
		description:
			'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.',
	},
	errorText: {
		id: 'fabric.atlassianSwitcher.errorText',
		defaultMessage:
			'We keep track of these errors, but feel free to contact us if refreshing doesn’t fix things',
		description: 'Text that is displayed when an unknown error happens in the Atlassian Switcher.',
	},
	errorImageAltText: {
		id: 'fabric.atlassianSwitcher.errorImageAltText',
		defaultMessage: 'A broken robot and a number of people busy fixing it.',
		description: 'Text displayed as alt text when an error occurs in the Atlassian Switcher',
	},
	errorTextNetwork: {
		id: 'fabric.atlassianSwitcher.errorTextNetwork',
		defaultMessage: 'We couldn’t load this list. Please reload the page and try again.',
		description: 'Text that is displayed when we detect a network issue.',
	},
	errorHeadingLoggedOut: {
		id: 'fabric.atlassianSwitcher.errorHeadingLoggedOut',
		defaultMessage: 'Your Atlassian account is logged out',
		description:
			'Heading of the error screen which is shown when an unknown error happens in the Atlassian Switcher. Usually due to failed network requests.',
	},
	errorHeadingUnverified: {
		id: 'fabric.atlassianSwitcher.errorHeadingUnverified',
		defaultMessage: 'Your account is unverified',
		description: 'Heading that is displayed when we detect user account is unverified.',
	},
	errorPartialResults: {
		id: 'fabric.atlassianSwitcher.errorPartialResults',
		defaultMessage: "We can't display some of your apps right now.",
		description:
			'Heading of the error message when available apps returns a partial result and 1 or more sites',
	},
	errorPartialResultsRefresh: {
		id: 'fabric.atlassianSwitcher.errorPartialResultsRefresh',
		defaultMessage: 'Refresh the page, or try again later.',
		description: 'Subtitle of the error message when available products returns a partial result',
	},
	errorTextUnverified: {
		id: 'fabric.atlassianSwitcher.errorTextUnverified',
		defaultMessage: 'Please confirm your email address to view a list of available products.',
		description: 'Text that is displayed when we detect user account is unverified.',
	},
	productDescriptionConfluence: {
		id: 'fabric.atlassianSwitcher.product.description.confluence',
		defaultMessage: 'Document collaboration',
		description: 'Text displayed under the Confluence product recommendation.',
	},
	productDescriptionJiraServiceManagement: {
		id: 'fabric.atlassianSwitcher.product.description.jsm',
		defaultMessage: 'Collaborative IT service management',
		description: 'Text displayed under the Jira Service Management product recommendation.',
	},
	productDescriptionJiraSoftware: {
		id: 'fabric.atlassianSwitcher.product.description.jsw',
		defaultMessage: 'Project and issue tracking',
		description: 'Text displayed under the Jira Software product recommendation.',
	},
	productDescriptionOpsgenie: {
		id: 'fabric.atlassianSwitcher.product.description.opsgenie',
		defaultMessage: 'Modern incident management',
		description: 'Text displayed under the Opsgenie product recommendation.',
	},
	productDescriptionCompass: {
		id: 'fabric.atlassianSwitcher.product.description.compass',
		defaultMessage: 'Component manager',
		description: 'Text displayed under the Compass product recommendation.',
	},
	join: {
		id: 'fabric.atlassianSwitcher.join',
		defaultMessage: 'Join',
		description:
			'Section Header in Atlassian Switcher. To set the expectation of what items would be shown in following section. Shown when an user has at least one joinable site via Domain Enabled Sign up with common collaborators.',
	},
	expandProductList: {
		id: 'fabric.atlassianSwitcher.expandProductList',
		defaultMessage: '{numItems} more',
		description: 'Text for the button that expands the product list in the Atlassian Switcher.',
	},
	collapseProductList: {
		id: 'fabric.atlassianSwitcher.contractProductList',
		defaultMessage: 'Less',
		description: 'Text for the button that collapses the product list in the Atlassian Switcher.',
	},
	emptyStateExploreProductsBodyAppify: {
		id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.body-appify',
		defaultMessage: 'Try an app to start collaborating with your team.',
		description:
			'The body text for the empty state explore products content, which prompts users to try new products.',
	},
	emptyStateExploreProductsLinkAppify: {
		id: 'fabric.atlassianSwitcher.emptyState.exploreProducts.link-appify',
		defaultMessage: 'Explore apps',
		description:
			'The text for the empty state explore products link, which prompts users to try new products.',
	},
	errorTextUnverifiedAppify: {
		id: 'fabric.atlassianSwitcher.errorTextUnverified-appify',
		defaultMessage: 'Please confirm your email address to view a list of available apps.',
		description: 'Text that is displayed when we detect user account is unverified.',
	},
});
export default messages;
